import { defineView } from "foldkit/submodel";

import { i18next } from "../../i18n";
import type { Shared } from "../shared";
import { Message } from "./message";
import type { Model } from "./model";

/** v1 `NotFound.tsx` verbatim (raw Tailwind, inline SVGs). */
export const view = defineView<Model, Message, Shared>((_model, _shared, h) =>
	h.section(
		[h.DataAttribute("testid", "page-NotFound"), h.Class("bg-base-100 ")],
		[
			h.div(
				[h.Class("container flex items-center  px-6 py-12 mx-auto")],
				[
					h.div(
						[
							h.Class(
								"flex flex-col items-center max-w-sm mx-auto text-center",
							),
						],
						[
							h.p(
								[
									h.Class(
										"p-3 text-sm font-medium text-primary rounded-full bg-primary/10",
									),
								],
								[
									h.svg(
										[
											h.Xmlns("http://www.w3.org/2000/svg"),
											h.Fill("none"),
											h.ViewBox("0 0 24 24"),
											h.StrokeWidth("2"),
											h.Stroke("currentColor"),
											h.Class("w-6 h-6"),
										],
										[
											h.title([], ["404"]),
											h.path(
												[
													h.StrokeLinecap("round"),
													h.StrokeLinejoin("round"),
													h.D(
														"M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z",
													),
												],
												[],
											),
										],
									),
								],
							),
							h.h1(
								[
									h.Class(
										"mt-3 text-2xl font-semibold text-base-content md:text-3xl",
									),
								],
								[i18next.t("notFound.title")],
							),
							h.p(
								[h.Class("mt-4 text-base-content/60")],
								[i18next.t("notFound.description")],
							),
							h.div(
								[
									h.Class(
										"flex items-center w-full mt-6 gap-x-3 shrink-0 sm:w-auto",
									),
								],
								[
									h.button(
										[
											h.Type("button"),
											h.Class("btn btn-outline w-1/2 sm:w-auto gap-x-2"),
											h.AriaLabel(i18next.t("notFound.goBack")),
											h.OnClick(Message.ClickedGoBack()),
										],
										[
											h.svg(
												[
													h.Xmlns("http://www.w3.org/2000/svg"),
													h.Fill("none"),
													h.ViewBox("0 0 24 24"),
													h.StrokeWidth("1.5"),
													h.Stroke("currentColor"),
													h.Class("w-5 h-5 rtl:rotate-180"),
													h.AriaHidden(true),
												],
												[
													h.path(
														[
															h.StrokeLinecap("round"),
															h.StrokeLinejoin("round"),
															h.D("M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"),
														],
														[],
													),
												],
											),
											h.span([], [i18next.t("notFound.goBack")]),
										],
									),
									h.a(
										[
											h.Href("/"),
											h.Class("btn btn-primary w-1/2 sm:w-auto"),
											h.AriaLabel(i18next.t("notFound.takeHome")),
										],
										[i18next.t("notFound.takeHome")],
									),
								],
							),
						],
					),
				],
			),
		],
	),
);
